import { atom } from "jotai";
import { AIMViewType, type AIMContextView } from "../InvestmentMemo.types";
import {
    rightDrawerOpenAtom,
    RightDrawerSize,
    rightDrawerSizeAtom,
} from "@/features/Navigation/state";

export const baseAIMContextViewAtom = atom<AIMContextView | null>(null);

export const AIMContextViewAtom = atom(
    (get) => get(baseAIMContextViewAtom),
    (get, set, newValue: AIMContextView | null) => {
        if (!newValue) {
            set(rightDrawerOpenAtom, false);
            set(baseAIMContextViewAtom, newValue);
        } else {
            set(baseAIMContextViewAtom, newValue);
            set(rightDrawerOpenAtom, true);

            if (newValue?.type === AIMViewType.DELTA_LINEAGE) {
                set(rightDrawerSizeAtom, RightDrawerSize.DEFAULT);
            } else {
                set(rightDrawerSizeAtom, RightDrawerSize.EXPANDED);
            }
        }
    },
);
